import React, { useEffect, useState, useMemo, useRef, useCallback } from 'react'
import { connect } from 'react-redux'
import * as actions from '../../redux/actions'
import { withWindowSizeListener } from 'react-window-size-listener'

import title from '../../constants/Menu'
import text from '../../constants/ListCompras'
import { imageBaseURL } from '../../services/defaultProps'
import {FaThumbsUp, FaThumbsDown} from 'react-icons/fa'
import '../../styles/containers/ListComprasPreview.css'
import { FiArrowLeft } from 'react-icons/fi'
import { useHistory, useLocation } from 'react-router-dom'
import Header from '../../components/Header'
import { LazyLoadImage } from 'react-lazy-load-image-component'
import useLanguage from '../../hooks/useLanguage'

const ListComprasGridWithoutListener = ({ language, photos, isUpload, nameCategory, category, hasNotification, windowSize: { windowWidth } }) => {
  const history = useHistory()

  const renderPhotos = useCallback(() => {
    const [imageWidth, setImageWidth] = useState(0)
    const imageRef = useRef(null)

    // TODO: make redirect to shoplist showcase
    const viewPhoto = useCallback(index => {
      const mappedPhotos = photos.map(photo => ({...photo,
        image: isUpload ? photo.image : imageBaseURL + photo.image}))

      if (isUpload) {
        history.push('/compras/visualizacao', {
          category,
          photo: index,
          photos: mappedPhotos
        })
      } else {
        history.push('/compras/visualizacao', {
          category,
          nameCategory,
          photo: index,
          photos: mappedPhotos
        })
      }
    }, [])

    /*
      listen the window width, when the window width changes, update
      the image width to calculate the new height based on the new width

      obs: similar to aspect-ratio property
    */
    useEffect(() => {
      setImageWidth(imageRef.current.offsetWidth)
    }, [windowWidth])

    return photos.map(({ image, id, status }, index) => {
      return (
        <div ref={imageRef} key={id} className='imagegridphotos-item listcompras-grid'
          style={{ height: imageWidth }} onClick={() => viewPhoto(index)}>
          <LazyLoadImage src={isUpload ? image : imageBaseURL + image} effect='blur'
            width='100%'
            height='100%'
            style={{
              objectFit: 'cover',
              objectPosition: 'center'
            }} />
          {!isUpload && status !== 'pending' && (
            <div className={`listcompras-item-overlay ${status}`}>
              {status === 'bought' ? (
                <div className='listcompras-item-status'>
                  <FaThumbsUp color='white' size={20} />
                  <p>{text.bought[language]}</p>
                </div>
              ) : (
                <div className='listcompras-item-status'>
                  <FaThumbsDown color='white' size={20} />
                  <p>{text.notBought[language]}</p>
                </div>
              )}
            </div>
          )}
          {hasNotification && <div className='listcompras-notification' />}
        </div>
      )
    })
  }, [photos, windowWidth])

  return (
    <div className='imagegridphotos-container'>
      {renderPhotos()}
    </div>
  )
}

const ListComprasGrid = withWindowSizeListener(ListComprasGridWithoutListener)

const ComprasPreview = props => {
  const history = useHistory()
  const location = useLocation()
  const category = useMemo(() => location.state.category, [])
  const nameCategory = useMemo(() => location.state.nameCategory, [])
  const photos = useMemo(() => location.state.category === 'upload' ? props.user.shopListImage
    : props.user.shopListTemplate.filter((item) => category === item.category.toLowerCase()))

  const language = useLanguage()

  if (!category) {
    history.push('/')
    return <div />
  }

  return (
    <div className='listcompras-grid-container'>
      <Header language={language} />
      <div className='listcompras-grid-title'>
        <FiArrowLeft onClick={() => history.goBack()}
          size={24} color='var(--primary)' className='listcompras-grid-goback' />
        <p>{category === 'upload' ? title.list[language] : nameCategory}</p>
      </div>
      {props.user.shopListText ? (
        <div className='listcompras-category-text'>
          {props.user.shopListText}
        </div>
      ) : (category === 'upload' && photos.length === 0) ? (
        <div className='empty-listcompras'>
          Sua lista de compras está vazia!
        </div>
      ) : photos.length === 0 ? (
        <div className='empty-listcompras'>
          Esta categoria está vazia
        </div>
      ) : (
        <ListComprasGrid language={language} isUpload={category === 'upload'} category={category} photos={photos} nameCategory={nameCategory} />
      )}
    </div>
  )
}

const mapStateToProps = (state) => {
  return {
    ...state.userReducer
  }
}

export default connect(mapStateToProps, actions)(ComprasPreview)



// WEBPACK FOOTER //
// ./src/containers/ListCompras/ListComprasPreview.js